import React from "react";
import { G, Rect, Text as SvgText } from "react-native-svg";

export type SvgLegendItem = { label: string; color: string };

const approxTextWidth = (text: string, fontSize: number) =>
  Math.min(520, Math.max(90, text.length * (fontSize * 0.56)));

export const getLegendLayout = (
  items: SvgLegendItem[],
  width: number,
  fontSize = 12,
  symbolSize = 10,
  colGap = 18,
  maxColumns = 3
) => {
  const avg = items.length
    ? items.reduce((s, it) => s + approxTextWidth(it.label, fontSize), 0) / items.length
    : 140;

  const estItemW = symbolSize + 6 + avg;
  const cols = Math.max(1, Math.min(maxColumns, Math.floor((width + colGap) / (estItemW + colGap))));
  const rows = Math.ceil(items.length / cols);
  const rowH = Math.max(symbolSize, fontSize) + 10;

  return { cols, rows, rowH, height: rows * rowH + 8 };
};

export const SvgLegend: React.FC<{
  x?: number;
  y?: number;
  width?: number;
  items: SvgLegendItem[];
  fontSize?: number;
  symbolSize?: number;
  maxColumns?: number;
}> = ({ x, y, width, items, fontSize = 12, symbolSize = 10, maxColumns = 3 }) => {
  const { cols, rowH } = getLegendLayout(items, width, fontSize, symbolSize, 18, maxColumns);
  const colW = width / cols;

  return (
    <G>
      {items.map((it, idx) => {
        const col = idx % cols;
        const row = Math.floor(idx / cols);
        const itemX = x + col * colW;
        const itemY = y + row * rowH;

        return (
          <G key={idx} transform={`translate(${itemX}, ${itemY})`}>
            <Rect
              x={0}
              y={-symbolSize + 3}
              width={symbolSize}
              height={symbolSize}
              rx={symbolSize / 2}
              ry={symbolSize / 2}
              fill={it.color}
            />
            <SvgText x={symbolSize + 6} y={2} fontSize={fontSize} fill="#111">
              {it.label}
            </SvgText>
          </G>
        );
      })}
    </G>
  );
};
